/* eslint-disable max-classes-per-file */
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';

export class LoadTenantChemicalExposureLog {
  static readonly type = '[Chemical Exposure] Load Tenant Chemical Exposure Log';
  constructor(public filter?: MainTableFilterModel) {}
}

export class ClearTenantChemicalExposureLog {
  static readonly type = '[Chemical Exposure] Clear Tenant Chemical Exposure Log';
}

export class ExportTenantChemicalExposureLogExcel {
  static readonly type = '[Chemical Exposure] Export Tenant Chemical Exposure Log Excel';
  constructor(public filter?: MainTableFilterModel) {}
}

export class PrintTenantChemicalExposureLogPdf {
  static readonly type = '[Chemical Exposure] Print Tenant Chemical Exposure Log Pdf';
  constructor(public filter?: MainTableFilterModel) {}
}
